import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CardBody } from 'reactstrap';
import { OAuthApp } from '../../../../APIClient';
import { MaterialIcon } from '../../../../components';
import { useTranslation } from '../../../../translations';
import { OAuthContainer } from './Container';

interface AuthorizedProps {
  readonly app: OAuthApp;
}

export const Denied: FC<AuthorizedProps> = ({ app }) => {
  const location = useLocation();
  const { ts } = useTranslation();
  useEffect(() => {
    setTimeout(() => {
      const params = new URLSearchParams(location.search);
      const redirectUri = params.get('redirect_uri')!;

      window.location.replace(`${redirectUri}?error=access_denied&state=${params.get('state')!}`);
    }, 2000);
  }, []);

  return (
    <OAuthContainer app={app}>
      <CardBody className="text-center">
        <MaterialIcon className="override" large name="dangerous" type="danger" />
        <h4>{ts('authorization_denied')}</h4>
        <p>
          {ts('you_have_refused_access_toappname')}: <strong>{app.name}</strong>.
        </p>
        <p>{ts('just_a_moment_while_we_redirect_you')}</p>
      </CardBody>
    </OAuthContainer>
  );
};
